import React, { createContext, useContext, useState, useEffect } from 'react';
import { useUser } from './UserContext';
import { httpsCallable, getFunctions } from "firebase/functions";

// Create a context for admin status
const AdminContext = createContext(null);

// Custom hook to use the admin context
export const useAdmin = () => useContext(AdminContext);

// Admin context provider component
export const AdminProvider = ({ children }) => {
  const { user } = useUser();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Reset admin status when user changes
    setIsAdmin(false);
    
    if (!user) {
      setIsLoading(false);
      return;
    }

    // Check if user is admin using the Cloud Function
    const checkAdminStatus = async () => {
      try {
        setIsLoading(true);
        const isAdminFn = httpsCallable(getFunctions(), 'isAdmin');
        const result = await isAdminFn();
        
        if (result.data && result.data.isAdmin) {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  // The value that will be provided to consumers of this context
  const value = {
    isAdmin,
    isLoading,
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};

export default AdminContext; 